export default {
    // 加载更多的  指令
    bind(el, binding) {
        const dropdownDom = el.querySelector('.el-select-dropdown__wrap')
        dropdownDom.addEventListener('scroll', function () {
            const condition = this.scrollHeight - this.scrollTop <= this.clientHeight+20
            if (condition) {
                binding.value && binding.value()
            }
        })
    },
}